import cx from "classnames";
import React, { ReactNode } from "react";

import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

export type CustomerInfoDisplayProps = {
  label: string;
  value: string | ReactNode;
  className?: string;
};

export const CustomerInfoDisplay = ({
  label,
  value,
  className,
}: CustomerInfoDisplayProps) => {
  return (
    <div className={cx(styles.container, className)}>
      <Text size="xxs" className={styles.label}>
        {label}
      </Text>
      <Text className={styles.header}>{value}</Text>
    </div>
  );
};
